import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { CheckboxInput } from "common/Input";

export const EditUserRoleModal = ({ isOpen, toggle, handleEditUserRole, user }) => {
    const [hasAdminRole, setHasAdminRole] = useState(false);

    const handleSubmit = async () => {
        await handleEditUserRole(user.id, !hasAdminRole);
        toggle();
    };

    useEffect(() => {
        if (user) {
            setHasAdminRole(user.roles.includes('ROLE_ADMIN'));
        }
    }, [isOpen]);

    return (
        <div>
            <Modal isOpen={isOpen} className="modal-md">
                <ModalHeader toggle={toggle}>Change Role</ModalHeader>
                <ModalBody style={{ paddingBottom: '2rem' }}>
                    <CheckboxInput
                        text="Admin Role"
                        name="Admin Role"
                        value={hasAdminRole}
                        isCheck={hasAdminRole}
                        checked={hasAdminRole}
                        onChange={handleSubmit}
                        style={{ marginRight: 10 }}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};
